import React from "react";
import Icon from "components/AppIcon";
import Tooltip from "components/Tooltip";

const METRIC_TOOLTIPS = {
  'Exposición Total': {
    title: 'Exposición Total',
    description: 'Valor de mercado actual de todo el metal en inventario, ponderado por el yield de cada categoría. Representa tu riesgo financiero total si el mercado se mueve.',
    example: '10.000 kg de cobre con yield 92% a 8.500 €/t = 78.200 € de exposición',
  },
  'Pérdida Potencial -5%': {
    title: 'Pérdida Potencial -5%',
    description: 'Cuánto perderías en euros si el precio benchmark de todos tus metales cae un 5% desde el valor actual. Escenario adverso leve.',
    example: 'Exposición 200.000 € × 5% = 10.000 € de pérdida potencial',
  },
  'Pérdida Potencial -10%': {
    title: 'Pérdida Potencial -10%',
    description: 'Cuánto perderías si el mercado cae un 10%. Escenario adverso severo. Úsalo como referencia para decidir si acelerar ventas o aumentar coberturas.',
    example: 'Exposición 200.000 € × 10% = 20.000 € de pérdida potencial',
  },
  'Lotes en Riesgo': {
    title: 'Lotes en Riesgo',
    description: 'Número de lotes activos que tienen P&L latente negativo o llevan más días en inventario de los configurados en Umbrales de Riesgo. Cada uno merece atención inmediata.',
  },
};

export default function ExposureMetrics({ metrics }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {metrics?.map((m) => {
        const tip = METRIC_TOOLTIPS?.[m?.label];
        return (
          <div key={m?.id} className="card p-4 lg:p-5 min-w-0">
            <div className="flex items-center justify-between mb-3">
              <div
                className="flex items-center justify-center w-9 h-9 rounded-md"
                style={{ background: m?.color + '20' }}
              >
                <Icon name={m?.icon} size={18} color={m?.color} strokeWidth={2} />
              </div>
              {m?.badge && (
                <span
                  className="text-xs font-caption px-2 py-0.5 rounded-full"
                  style={{ background: m?.badgeColor + '20', color: m?.badgeColor }}
                >
                  {m?.badge}
                </span>
              )}
            </div>
            <p className="font-data text-xl lg:text-2xl font-bold text-foreground whitespace-nowrap">
              {m?.value}
            </p>
            {tip ? (
              <Tooltip title={tip?.title} description={tip?.description} example={tip?.example}>
                <p className="text-sm font-caption text-muted-foreground mt-1">{m?.label}</p>
              </Tooltip>
            ) : (
              <p className="text-sm font-caption text-muted-foreground mt-1">{m?.label}</p>
            )}
            {m?.sub && (
              <p className="text-xs font-caption mt-1" style={{ color: m?.subColor || 'var(--color-muted-foreground)' }}>
                {m?.sub}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}